import styled from "styled-components"
import { AdminLeftHeader, AdminTopHeader } from "../components/Header"

export const Messages = () => {
    return (
        <>
            <AdminTopHeader />
            <AdminLeftHeader />
            <MessagesP>
                <UserList>
                    <h2>People</h2>
                    <div className="users">
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>

                        </div>
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>

                        </div>
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>

                        </div>
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>

                        </div>
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>

                        </div>
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>

                        </div>
                        <div className="item">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                <p>mirabzalozodov07@gmail.com</p>
                                <div className="time">
                                    <time datetime="12/12/12">12/12/12</time>
                                </div>
                                <div className="badge">
                                    <span>12</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </UserList>
                <Direct>
                    {/* <Empty></Empty> */}
                    <div className="direct-header">
                        <div className="user">
                            <img className="user-img" src="https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D" alt="" />
                            <div className="username">
                                <h4>Ozodov Mirabzal</h4>
                                {/* (<time datetime="12/12/12">12/12/12</time>) */}
                                <p>mir***07@gmail.com</p>
                            </div>
                        </div>
                        <div className="icons">
                            <div className="item">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                    </div>
                    <div className="direct-body">
                        <div className="messages">
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem perferendis officiis architecto nesciunt quibusdam eum culpa earum harum ad asperiores nam, dolores suscipit, soluta at deserunt sequi laboriosam reiciendis enim?</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa soluta consequuntur voluptates, quisquam quia exercitationem necessitatibus eius cum nihil omnis.</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem perferendis officiis architecto nesciunt quibusdam eum culpa earum harum ad asperiores nam, dolores suscipit, soluta at deserunt sequi laboriosam reiciendis enim?</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa soluta consequuntur voluptates, quisquam quia exercitationem necessitatibus eius cum nihil omnis.</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem perferendis officiis architecto nesciunt quibusdam eum culpa earum harum ad asperiores nam, dolores suscipit, soluta at deserunt sequi laboriosam reiciendis enim?</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item received" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit.</p>
                            </div>
                            <div className="item sent" title="12/12/2024 09:42">
                                <p>Lorem ipsum dolor sit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa soluta consequuntur voluptates, quisquam quia exercitationem necessitatibus eius cum nihil omnis.</p>
                            </div>
                        </div>
                    </div>
                    <div className="direct-footer">
                        <div className="form-group">
                            <textarea placeholder="Type your message here..." ></textarea>
                        </div>
                        <div className="sent">
                            <button><i class="fa-solid fa-paper-plane"></i></button>
                        </div>
                    </div>
                </Direct>
            </MessagesP>
        </>
    )
}

const MessagesP = styled.div`
    gap: 32px;
    left: 332px;
    display: flex;
    height: 100dvh;
    position: fixed;
    padding: 32px 0;
    overflow-y: auto;
    align-items: flex-start;
    width: calc(100% - 364px);

    @media (max-width: 1300px) {
        display: block;
    }

    @media (max-width: 992px) {
        left: 16px;
        margin-top: 0;
        width: calc(100% - 32px);
        height: calc(100dvh - 128px);
    } 
`

const UserList = styled.div`
    width: 40%;
    height: 100%;
    padding: 24px;
    min-width: 300px;
    overflow-y: auto;
    border-radius: 12px;
    background: var(--white);

    h2 {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        line-height: 30px;
        color: var(--black);
        text-transform: capitalize;
    }

    .users {
        margin-top: 24px;
    }

    .users .item {
        gap: 12px;
        display: flex;
        padding: 12px 6px;
        position: relative;
        align-items: center;
        border-bottom: 1px solid var(--darkWhite);
    }

    .users .item.active,
    .users .item:hover {
        background: var(--darkWhite);
    }

    .users .item .user-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .users .item .username h4 {
        font-size: 16px;
        text-align: left;
        font-weight: 600;
        line-height: 24px;
        color: var(--black);
        text-transform: capitalize;
    }

    .users .item .username p {
        opacity: 60%;
        font-size: 14px;
        text-align: left;
        font-weight: 400;
        line-height: 20px;
        color: var(--black);
    }

    .users .item .username .time {
        top: 5px;
        right: 5px;
        font-size: 16px;
        font-weight: 500;
        font-weight: 400;
        padding: 3px 6px;
        line-height: 16px;
        text-align: center;
        position: absolute;
        border-radius: 50px;
        color: var(--mainCl);
        background: var(--lightOrange);
    }

    .users .item .username .badge {
        right: 5px;
        bottom: 5px;
        width: 25px;
        height: 25px;
        display: flex;
        position: absolute;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        background: var(--black);
    }

    .users .item .username .badge span {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: var(--white);
    }

    @media (max-width: 1300px) {
        width: 100%;
    }
`

const Direct = styled.div`
    width: 60%;
    height: 100%;
    padding: 24px;
    min-width: 400px;
    position: relative;
    border-radius: 12px;
    background: var(--white);

    .direct-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .direct-header .user {
        gap: 24px;
        display: flex;
        align-items: center;
    }

    .direct-header .user .user-img {
        width: 50px;
        height: 50px;
        object-fit: cover;
        border-radius: 50%;
    }

    .direct-header .user .username h4 {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: var(--black);
        text-transform: capitalize;
    }

    .direct-header .user .username p {
        opacity: 60%;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: var(--black);
        text-transform: lowercase;
    }

    .direct-header .user .username time {
        color: var(--mainCl);
    }

    .direct-header .icons {
        gap: 12px;
        display: flex;
        align-items: center;
    }

    .direct-header .icons .item {
        width: 30px;
        height: 30px;
        display: flex;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        background: var(--darkWhite);
    }

    .direct-header .icons .item i {
        font-size: 16px;
        color: var(--mainCl);
    }

    .direct-body {
        width: 100%;
        height: 450px;
        padding: 12px;
        margin-top: 24px;
        overflow-y: auto;
    }

    .direct-body .messages {
        display: flex;
        flex-direction: column;
    }

    .direct-body .messages .item {
        margin: 10px 0;
        padding: 6px 12px;
        width: fit-content;
        border-radius: 12px;
        background: var(--darkWhite);
    }

    .direct-body .messages .item p {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }

    .direct-body .messages .item.received {
        align-self: flex-start;
    }

    .direct-body .messages .item.sent  {
        align-self: flex-end;
        background: var(--mainCl);
    }

    .direct-body .messages .item.sent p {
        color: var(--white);
    }

    .direct-footer {
        gap: 24px;
        width: 100%;
        display: flex;
        height: 100px;
        padding: 12px;
        align-items: flex-start;
    }

    .direct-footer .form-group {
        width: 100%;
    }

    .direct-footer .form-group textarea {
        outline: 0;
        width: 100%;
        resize: none;
        padding: 12px;
        border-radius: 12px;
        border: 2px solid var(--darkWhite);
    }

    .direct-footer .form-group textarea::placeholder {
        opacity: 60%;
        font-size: 14px;
        line-height: 20px;
        color: var(--black);
    }

    .direct-footer .sent {
        width: 50px;
        height: 50px;
        flex-shrink: 0;
    }

    .direct-footer .sent button {
        border: 0;
        outline: 0;
        width: 100%;
        height: 100%;
        font-size: 24px;
        line-height: 30px;
        color: var(--white);
        border-radius: 12px;
        background: var(--mainCl);
    }

    @media (max-width: 1300px) {
        width: 100%;
        margin-top: 32px;
    }
`